import { render, staticRenderFns } from "./FormEpisodeCollapse.vue?vue&type=template&id=2b833aac"
import script from "./FormEpisodeCollapse.vue?vue&type=script&lang=js"
export * from "./FormEpisodeCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports